import type { RouteRecordRaw } from 'vue-router';
import { RouteNames } from '../config/route-names';

/**
 * Agent 系统异步路由配置
 * 供猎头端用户使用的路由
 */
export const asyncAgentRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '/post/detail',
        name: RouteNames.JobDetail,
        component: () => import('@/views/job/detail/index.vue'),
        meta: {
          title: 'menu.jobDetail',
          hidden: true,
          activeMenu: '/post/list',
          requiresAuth: true,
        }
      },
      {
        path: '/data-summary',
        name: RouteNames.DataSummary,
        meta: {
          title: 'menu.dataSummary',
          icon: 'dataview',
          showInMenu: true,
          requiresAuth: false,
        },
        children: [
          {
            path: '/data-summary/overview',
            name: RouteNames.DataOverview,
            component: () => import('@/views/dataSummary/agent/index.vue'),
            meta: {
              title: 'menu.dataOverview',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/data-summary/my-board',
            name: RouteNames.MyBoard,
            component: () => import('@/views/dataSummary/agent/MyBoard.vue'),
            meta: {
              title: 'menu.myBoard',
              showInMenu: true,
              requiresAuth: true,
            }
          },
        ]
      },
      {
        path: '/post',
        name: RouteNames.JobManage,
        meta: {
          title: 'menu.jobMananger',
          icon: 'job-nav',
          showInMenu: true,
          requiresAuth: false,
        },
        children: [
          {
            path: '/post/list',
            name: RouteNames.AgentJobList,
            component: () => import('@/views/job/agent-list/index.vue'),
            meta: {
              title: 'menu.agentJobList',
              showInMenu: true,
              requiresAuth: true,
            },
          },
          {
            path: '/post/business-manage',
            name: RouteNames.BusinessManage,
            component: () => import('@/views/job/business-manage/index.vue'),
            meta: {
              title: 'menu.businessManage',
              showInMenu: true,
              requiresAuth: true,
            },
          },
        ]
      },
      
      {
        path: '/recruitment',
        name: RouteNames.Candidate,
        meta: {
          title: 'menu.candidate',
          icon: 'users',
          showInMenu: true,
          // 有二级菜单的需要配置requiresAuth:false，避免父级菜单被权限过滤掉
          requiresAuth: false,
        },
        children: [
          {
            path: '/recruitment/selection/list',
            name: RouteNames.CandidateSelecting,
            component: () => import('@/views/candidate/selecting/index.vue'),
            meta: {
              title: 'menu.candidateSelecting',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/list',
            name: RouteNames.CandidateRegistered,
            component: () => import('@/views/candidate/registered/index.vue'),
            meta: {
              title: 'menu.candidateRegistered',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/edit',
            name: RouteNames.CandidateEdit,
            component: () => import('@/views/candidate/registered/edit/index.vue'),
            meta: {
              title: 'menu.candidateEdit',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/candidate/list',
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/detail',
            name: RouteNames.CandidateDetail,
            component: () => import('@/views/candidate/registered/detail/index.vue'),
            meta: {
              title: 'menu.candidateDetail',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/candidate/list',
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/selection/detail',
            name: RouteNames.CandidateSelectingDetail,
            component: () => import('@/views/candidate/selecting/detail/index.vue'),
            meta: {
              title: 'menu.candidateSelectingDetail',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/selection/list',
              requiresAuth: true,
            }
          },
        ]
      },
      {
        path: '/chat',
        name: RouteNames.Chat,
        component: () => import('@/views/chat/index.vue'),
        meta: {
          title: 'menu.companyChat',
          icon: 'chat',
          showInMenu: true,
          requiresAuth: true,
        }
      },
      {
        path: 'settings',
        name: RouteNames.Settings,
        redirect: '/company',
        meta: {
          title: 'menu.settings',
          icon: 'setting',
          showInMenu: true,
          requiresAuth: false
        },
        children: [
          {
            path: '/setting/account/list',
            name: RouteNames.Account,
            component: () => import('@/views/account/index.vue'),
            meta: {
              title: 'menu.account',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/account/detail',
            name: RouteNames.AccountDetail,
            component: () => import('@/views/account/detail.vue'),
            meta: {
              hidden: true,
              title: 'menu.accountDetail',
              requiresAuth: false
            }
          },
          {
            path: '/setting/selection',
            name: RouteNames.InterviewSettingAgent,
            component: () => import('@/views/settings/interview-agent.vue'),
            meta: {
              title: 'menu.interviewSetting',
              showInMenu: true,
            }
          },
          {
            path: '/setting/channel_source/list',
            name: RouteNames.InterviewChannel,
            component: () => import('@/views/settings/interview-channel/index.vue'),
            meta: {
              title: 'menu.interviewChannel',
              activeMenu: '/setting/selection',
              hidden: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/notify',
            name: RouteNames.Notify,
            component: () => import('@/views/settings/notify/index.vue'),
            meta: {
              title: 'menu.notify',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/notify/settings',
            name: RouteNames.NotifySettings,
            component: () => import('@/views/settings/notify/settings.vue'),
            meta: {
              title: 'menu.notifySettings',
              activeMenu: '/setting/notify',
              hidden: true,
              requiresAuth: true,
            }
          },
        ]
      },
      // 404错误页面路由
      {
        path: '/404',
        name: RouteNames.Error404,
        component: () => import('@/views/error/404.vue'),
        meta: { hidden: true, title: 'menu.error404', requiresAuth: false }
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
        meta: { hidden: true, requiresAuth: false}
      },

      // 403无权限页面 - 全屏展示，不在布局内
      {
        path: '/403',
        name: RouteNames.Error403,
        component: () => import('@/views/error/403.vue'),
        meta: { hidden: true, title: 'menu.error403', requiresAuth: false }
      }
    ]
  },
];
